import {
  ADD_MULTIPLE_EQUIPMENT_AND_POINTS,
  REMOVE_MULTIPLE_EQUIPMENT,
  DELETE_ALL_EQUIPMENT,
} from './actiontypes';
import { getAllEquipmentForBuilding, getAllDevicesForBuilding } from '../../api/Api';
import { setBuildingLoading, setBuildingNotLoading } from './ui';
import { addDevicesAction } from './devices';
import { getOrgsBuildings } from '../selectors/buildings';

export function deleteAllEquipmentAction() {
  return {
    type: DELETE_ALL_EQUIPMENT,
  };
}

export function addMultipleEquipmentAndPointsAction({ equipment }) {
  return {
    type: ADD_MULTIPLE_EQUIPMENT_AND_POINTS,
    equipment,
  };
}

export function removeMultipleEquipmentAction(buildingId, equipmentIds) {
  return {
    type: REMOVE_MULTIPLE_EQUIPMENT,
    buildingId,
    equipmentIds,
  };
}

export function fetchEquipForBuildingActionCreator(
  buildingId,
  getPoints = true,
  getDevices = false,
  jwt = null,
  force = false
) {
  return (dispatch, getState) => {
    // if the building already has up to date equipment, abort fetch
    const state = getState();
    if (!jwt) {
      // easier to do this than to rework all usages of the action creator
      // eslint-disable-next-line no-param-reassign
      jwt = state.user.jwt;
    }
    const equip = state.entities.buildings.equipment[buildingId];
    if (!force && equip && equip.receivedAt && !equip.isInvalid) {
      return Promise.resolve();
    }

    // let the UI know we're loading the building
    dispatch(setBuildingLoading(buildingId));

    return getAllEquipmentForBuilding(buildingId, jwt, getPoints)
      .then((equipment) => {
        dispatch(addMultipleEquipmentAndPointsAction({ equipment }));
      })
      .then((response) => {
        if (getDevices) {
          getAllDevicesForBuilding(buildingId, jwt).then((res) => dispatch(addDevicesAction(res)));
        }
        return response;
      })
      .finally(() => dispatch(setBuildingNotLoading(buildingId)));
  };
}

export function fetchEquipForAllBuildingsActionCreator(org, getPoints = true, getDevices = false) {
  return (dispatch, getState) => {
    const state = getState();
    const {
      user: { jwt },
    } = state;
    const buildingIds = getOrgsBuildings(state, org).map((b) => b.id);
    buildingIds.forEach((bid) =>
      dispatch(fetchEquipForBuildingActionCreator(bid, getPoints, getDevices, jwt))
    );
  };
}
